module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2021652d26de5ace82ba052a6584e998.png";